import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { RouterModule } from '@angular/router';
import { APP_CONSTANTS } from 'src/app/core/constant/constants';
import { ShortNumberPipe } from 'src/app/shared/pipe/shor-number.pipe';
import { SolesCurrencyPipe } from 'src/app/shared/pipe/soles-currency.pipe';
import { TimeAgoPipe } from 'src/app/shared/pipe/time-ago.pipe';

@Component({
  selector: 'app-top-section',
  imports: [TimeAgoPipe, RouterModule, CommonModule, SolesCurrencyPipe, ShortNumberPipe],
  templateUrl: './top-section.component.html',
  styles: ``
})
export class TopSectionComponent implements OnChanges {
  @Input() jobs: JobOffers[] = [];
  isLoading = true;
  collection = [1, 2, 3]

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['jobs']) {
      if (this.jobs?.length) {
        this.prepareJobs();
        this.isLoading = false;
      } else {
        this.isLoading = true;
      }
    }
  }

  prepareJobs(): void {
    this.jobs = [...this.jobs].sort((a, b) =>
      new Date(b.publicationDate).getTime() - new Date(a.publicationDate).getTime()
    );
  }

  ShowSalary(job: JobOffers): boolean {
    if (job.showSalary === '1') {
      return true;
    } else {
      return false;
    }
  }

  companyImage(job: JobOffers): string {
    const url = job.companyUrlBannerMini;
    if (!url || url.trim() === '') {
      return APP_CONSTANTS.DEFAULT_IMAGE_COMPANY;
    }
    return url;
  }
}
